export const ALLOWED_TAGS = ['ul', 'ol', 'li', 'strong', 'em', 'div', 'p', 'br'];
